(function () {
  var STORAGE_KEY = 'cartTimerExpiresAt';

  function tick() {
    var el = document.getElementById('CartTimer');
    var valueEl = document.getElementById('CartTimerValue');

    if (!el || !valueEl) {
      window.localStorage.removeItem(STORAGE_KEY);
      return;
    }

    var minutes = Number(el.dataset.minutes) || 15;
    var expiresAt = Number(window.localStorage.getItem(STORAGE_KEY));

    if (!expiresAt || isNaN(expiresAt)) {
      expiresAt = Date.now() + minutes * 60000;
      window.localStorage.setItem(STORAGE_KEY, String(expiresAt));
    }

    var remaining = Math.max(0, expiresAt - Date.now());

    if (remaining <= 0) {
      el.style.display = 'none';
      window.localStorage.removeItem(STORAGE_KEY);
      return;
    }

    var totalSeconds = Math.ceil(remaining / 1000);
    var mm = Math.floor(totalSeconds / 60);
    var ss = totalSeconds % 60;
    valueEl.textContent = String(mm).padStart(2, '0') + ':' + String(ss).padStart(2, '0');
  }

  tick();
  setInterval(tick, 1000);
})();
